import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IDestinataire, defaultValue } from 'app/shared/model/destinataire.model';

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IDestinataire>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
  totalItems: 0,
};

const apiUrl = 'api/destinataires';

// Actions

export const getDestinataires = createAsyncThunk('destinataire/fetch_destinataire_list', async (entity: any) => {
  const requestUrl = `${apiUrl}/ecole/${entity.ecoleId}?anneeScolaireId=${entity.anneeScolaireId}&page=${entity.page}&size=${entity.size}`;
  return axios.get<IDestinataire[]>(requestUrl);
});

export const getDestinataire = createAsyncThunk(
  'destinataire/fetch_destinataire',
  async (id: string | number) => {
    const requestUrl = `${apiUrl}/${id}`;
    return axios.get<IDestinataire>(requestUrl);
  },
  { serializeError: serializeAxiosError }
);

export type DestinataireState = Readonly<typeof initialState>;
export const DestinataireSlice = createEntitySlice({
  name: 'destinataire',
  initialState: initialState as DestinataireState,
  extraReducers(builder) {
    builder
      .addCase(getDestinataire.fulfilled, (state, action) => {
        state.loading = false;
        state.entity = action.payload.data;
      })
      .addMatcher(isFulfilled(getDestinataires), (state, action) => {
        return {
          ...state,
          loading: false,
          entities: action.payload.data,
          totalItems: parseInt(action.payload.headers['x-total-count'], 10),
        };
      })
      .addMatcher(isPending(getDestinataires, getDestinataire), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      });
  },
});

export const { reset } = DestinataireSlice.actions;

// Reducer
export default DestinataireSlice.reducer;
